import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './Pages.css';

function Invoices({ apiUrl, token }) {
  const [invoices, setInvoices] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .get(`${apiUrl}/invoices`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setInvoices(res.data))
      .catch(() => setError('Failed to fetch invoices'));
  }, [apiUrl, token]);

  const total = invoices.reduce((sum, inv) => sum + parseFloat(inv.amount || 0), 0).toFixed(2);
  const unpaid = invoices
    .filter((inv) => inv.status === 'unpaid')
    .reduce((sum, inv) => sum + parseFloat(inv.amount || 0), 0)
    .toFixed(2);

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Invoices</h1>
      </div>

      {error && <div className="error-message">{error}</div>}

      {invoices.length > 0 && (
        <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', marginBottom: 24 }}>
          <div className="stat-tile">
            <div className="stat-value">${total}</div>
            <div className="stat-label">Total Invoiced</div>
          </div>
          <div className="stat-tile">
            <div className="stat-value">${unpaid}</div>
            <div className="stat-label">Outstanding</div>
          </div>
        </div>
      )}

      <div className="list-container table-wrap">
        {invoices.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>Service</th>
                <th>Practitioner</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td>{invoice.service_name}</td>
                  <td>{invoice.practitioner_name}</td>
                  <td>${parseFloat(invoice.amount).toFixed(2)}</td>
                  <td><span className={`badge badge-${invoice.status}`}>{invoice.status}</span></td>
                  <td>{new Date(invoice.created_at).toLocaleDateString()}</td>
                  <td>
                    {invoice.status === 'unpaid' ? (
                      <Link to={`/bookings/${invoice.booking_id}`} className="btn btn-primary btn-sm">Pay Now</Link>
                    ) : (
                      <Link to={`/bookings/${invoice.booking_id}`} className="btn btn-secondary btn-sm">View</Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="empty-state">No invoices yet.</p>
        )}
      </div>
    </div>
  );
}

export default Invoices;
